// src/redux/actions/reviewsActions.js

// import instance from '../../../axios';
import axios from "axios";

export const FETCH_SHOPIFY_SHOP_INFO = "FETCH_SHOPIFY_SHOP_INFO";
export const FETCH_SHOPIFY_SHOP_INFO_SUCCESS = "FETCH_SHOPIFY_SHOP_INFO_SUCCESS";
export const FETCH_SHOPIFY_SHOP_INFO_FAILURE = "FETCH_SHOPIFY_SHOP_INFO_FAILURE";

export const fetchShopifyShopInfoRequest = () => {
    return {
        type: FETCH_SHOPIFY_SHOP_INFO,
    };
};

export const fetchShopifyShopInfoSuccess = (shopifyShopInfo) => {
    return {
        type: FETCH_SHOPIFY_SHOP_INFO_SUCCESS,
        payload: shopifyShopInfo,
    };
};

export const fetchShopifyShopInfoFailure = (error) => {
    return {
        type: FETCH_SHOPIFY_SHOP_INFO_FAILURE,
        payload: error,
    };
};

const apiUrl = "api/shopify-shop-info";

export const getShopifyShopInfo = () => {
    return async (dispatch) => {
        dispatch(fetchShopifyShopInfoRequest());
        try {
            const response = await axios.get(apiUrl);
            dispatch(fetchShopifyShopInfoSuccess(response.data));
        } catch (error) {
            dispatch(fetchShopifyShopInfoFailure(error.message));
        }
    };
};


